module.exports = __webpack_public_path__ + "img/7.a06b76a0.jpeg";